import React from 'react';
import { useEmojis } from '../../hooks/useEmojis';

interface SlackEmojiProps {
  shortcode: string;
  size?: number;
  className?: string;
}

export const SlackEmoji: React.FC<SlackEmojiProps> = ({ 
  shortcode, 
  size = 20, 
  className = '' 
}) => {
  const { data: emojiMap } = useEmojis();
  
  // Remove colons if present
  const cleanCode = shortcode.replace(/^:|:$/g, '');
  const imageUrl = emojiMap?.[cleanCode];

  if (!imageUrl) {
    // Return the shortcode as text if emoji not found
    return <span className={className}>:{cleanCode}:</span>;
  }

  return (
    <img
      src={imageUrl}
      alt={`:${cleanCode}:`}
      title={`:${cleanCode}:`}
      style={{ width: size, height: size }}
      className={`inline-block align-middle ${className}`}
    />
  );
};

interface EmojiTextProps {
  text: string;
  emojiSize?: number;
  className?: string;
}

export const EmojiText: React.FC<EmojiTextProps> = ({ 
  text, 
  emojiSize = 20, 
  className = '' 
}) => {
  const { data: emojiMap } = useEmojis();

  if (!emojiMap || Object.keys(emojiMap).length === 0) {
    // Return plain text if no emojis loaded
    return <span className={className}>{text}</span>;
  }

  // Match :shortcode: patterns
  const parts = text.split(/(:[\w-]+:)/g);

  return (
    <span className={className}>
      {parts.map((part, index) => {
        // Check if this part is an emoji shortcode
        const match = part.match(/^:([\w-]+):$/);
        if (match) {
          const cleanCode = match[1];
          const imageUrl = emojiMap[cleanCode];
          
          if (imageUrl) {
            return (
              <img
                key={index}
                src={imageUrl}
                alt={`:${cleanCode}:`}
                title={`:${cleanCode}:`}
                style={{ width: emojiSize, height: emojiSize }}
                className="inline-block align-middle mx-0.5"
              />
            );
          }
        }
        return <span key={index}>{part}</span>;
      })}
    </span>
  );
};

export default SlackEmoji;
